/** @format */

import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form,
  Select,
  Input,
  Radio,
  // Upload,
  Checkbox,
  Space,
} from "antd";
import moment from "moment";
import "moment/locale/id";
// import type { UploadProps } from "antd";
import {
  getFirstSumberDanaBOS,
  getLaporanDokumenPengajuan,
  getNamePenerimaBOS,
} from "../../../../utils/helper/helperBos";
// import { UploadOutlined } from "@ant-design/icons";
import { addFormData, extensionFile, uuidv4 } from "../../../../utils/helper";
import { ButtonUpload } from "../../../../components/Uploads";
import {
  editDokumenPengajuanBOS,
  postDokumenPengajuanBOS,
} from "../../../../services/v2/planningservice/rencanapengajuanbos";
import notifAlert from "../../../../components/NotifAlert";
import { postBerkasRencana } from "../../../../services/v2/planningservice";
import { ButtonTableDelete } from "../../../../components/Button";

type FormActionType = {
  openModal: boolean;
  title: string;
  store: any;
  data: any;
  dokumenId: any;
  isAuth: any;
  handleOpenDokumen: (values: any) => void;
  handleGetData: () => void;
  handleClose: () => void;
};

const ModalPengajuanDokumen = ({
  openModal,
  title,
  dokumenId,
  data,
  store,
  isAuth,
  handleOpenDokumen,
  handleGetData,
  handleClose,
}: FormActionType) => {
  const tmpSumberDana = store.sumberDana || [];
  const isYear = isAuth?.isTahun;
  const [form] = Form.useForm();
  const [tipe, setTipe] = useState<any>(null);
  const [tipeLaporan, setTipeLaporan] = useState<any>(null);
  const [updateFileDoc, setUpdateFileDoc] = useState<any>(false);
  const [id, setID] = useState(uuidv4());
  const listMonth = moment.months();
  const [errorUpload, setErrorUpload] = useState<any>(null);
  const typePenerimaBOS = getNamePenerimaBOS();
  const [loading, setLoading] = useState<any>(false);
  const [validUpload, setValidUpload] = useState<any>([]);
  const tmpListLaporanPengajuan = getLaporanDokumenPengajuan();
  const tmpExtensionFile = extensionFile();

  useEffect(() => {
    if (data) {
      setTipeLaporan(data?.kode);
      setTipe(data?.jenis_doc);
      setID(data?.id);
      setUpdateFileDoc(
        data?.namatemplate && data?.jenis_doc === "dokumen" ? true : false,
      );
      form.setFieldsValue({
        kode: data?.kode,
        nama: data?.nama,
        jenis: data?.jenis_doc,
        laporan: data?.kode,
        penerimaBos: data?.penerima_bos,
        tipeFile: data?.typedoc,
        month: data?.periode?.isMonth || [],
        year: data?.periode?.isYear || null,
        sumberDana: data?.periode?.sumberDana || null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleReset = () => {
    setID(uuidv4());
    form.resetFields();
    setTipe(null);
    setTipeLaporan(null);
    handleClose();
    setValidUpload([]);
  };

  //   const validateKode = (_, values) => {
  //     const val = values.toLowerCase();

  //     const checkKode: any =
  //       refSumberDana
  //         .filter((item) => !item.id.includes(id))
  //         .filter(
  //           (item) =>
  //             item.kode !== null &&
  //             (item.kode || "").toString().toLowerCase() === val,
  //         ) || null;
  //     if (checkKode.length) {
  //       return Promise.reject("Kode Sudah Digunakan!");
  //     } else {
  //       return Promise.resolve();
  //     }
  //   };

  const handleChange = (values: any) => {
    for (let obj in values) {
      if (obj === "jenis") {
        setTipe(values[obj]);
      }
      if (obj === "laporan") {
        setTipeLaporan(values[obj]);
        form.setFieldsValue({ kode: values[obj] });
      }
    }
  };

  const checkFiles = (values: any) => {
    let messageTmp: any = { status: "success", messages: "" };
    if (!values.length) {
      setErrorUpload({
        status: "error",
        messages: "Maaf dokumen tidak boleh kosong!",
      });
      return Promise.reject();
    } else {
      setErrorUpload(messageTmp);
      return Promise.resolve();
    }
  };

  const validationAfterUpload = (values: any) => {
    setValidUpload(values || []);
    checkFiles(values);
  };

  const handleSaveUpload = async (fileUpload: any) => {
    if (fileUpload.length) {
      let fileUploadTmp: any = [];
      fileUpload.map(async (item: any) => {
        fileUploadTmp.push(item.originFileObj);
      });
      let payload: any = {
        idRincianRencanaKegiatan: id,
        tahun: isYear,
        nsm: dokumenId?.id,
        file: fileUploadTmp,
      };
      let params: any = addFormData(payload);

      try {
        return await postBerkasRencana(params);
      } catch (error) {
        console.log(error);
        return null;
      }
    }
  };

  const handleSave = async (values: any) => {
    setLoading(true);

    let upFile: any = null;
    if (values.jenis !== "laporan" && validUpload.length && !updateFileDoc) {
      upFile = await handleSaveUpload(validUpload);
    } else {
      upFile = {
        fileUrl: data?.urltemplate || "-",
        fileName: data?.namatemplate || "-",
        fileType: data?.typetemplate || "-",
      };
    }

    const payload = {
      id: id,
      nama: values?.nama,
      kode: values?.kode,
      urltemplate: (values.jenis === "laporan" && "-") || upFile?.fileUrl,
      namatemplate: (values.jenis === "laporan" && "-") || upFile?.fileName,
      typetemplate: (values.jenis === "laporan" && "-") || upFile?.fileType,
      djadwal_pengajuan_id: dokumenId?.id,
      typedoc: (values.jenis === "laporan" && "") || values?.tipeFile,
      penerima_bos: values?.penerimaBos,
      jenis_doc: values.jenis,
      periode:
        (values?.laporan === "docLpj" && {
          isMonth: values?.month || [],
          isYear: values?.year,
          sumberDana: values?.sumberDana,
        }) ||
        {},
    };

    try {
      if (title === "Tambah") {
        await postDokumenPengajuanBOS(payload);
      } else {
        await editDokumenPengajuanBOS(payload);
      }

      notifAlert({
        type: "success",
        description: "Dokumen pengajuan berhasil di simpan",
      });
      handleGetData();
      handleReset();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <Modal
      open={openModal}
      title={`${title} Dokumen Pengajuan`}
      width={1200}
      onCancel={handleReset}
      footer={[
        <Button loading={loading} onClick={handleReset}>
          Batal
        </Button>,
        <Button loading={loading} type="primary" onClick={() => form.submit()}>
          Simpan
        </Button>,
      ]}>
      <Form
        form={form}
        key="formPengajuanBos"
        name="formPengajuanBos"
        layout="vertical"
        onFinish={handleSave}
        onValuesChange={handleChange}>
        <div className="flex flex-row md:flex-col gap-4">
          <div className="flex-1">
            <Form.Item
              label="Jenis"
              name="jenis"
              rules={[
                {
                  required: true,
                  message: "Jenis tidak boleh kosong!",
                },
              ]}>
              <Radio.Group>
                <Radio value="laporan">Laporan</Radio>
                <Radio value="dokumen">Dokumen</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className="flex-1">
            <Form.Item
              label="Penerima BOS"
              name="penerimaBos"
              rules={[
                {
                  required: true,
                  message: "Penerima BOS tidak boleh kosong!",
                },
              ]}>
              <Radio.Group
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}>
                {typePenerimaBOS
                  // eslint-disable-next-line array-callback-return
                  .filter(
                    (item: any, i: any) =>
                      (!getFirstSumberDanaBOS().includes(
                        dokumenId?.sumberdana,
                      ) &&
                        true) ||
                      i !== 2,
                  )
                  .map((item: any, i: any) => {
                    return (
                      <Radio
                        value={item.kode}>{`${item.name} ${isYear}`}</Radio>
                    );
                  })}
              </Radio.Group>
            </Form.Item>
          </div>
        </div>
        {tipe === "laporan" && (
          <Form.Item
            label="Laporan"
            name="laporan"
            rules={[
              {
                required: true,
                message: "Laporan tidak boleh kosong!",
              },
            ]}>
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Pilih Laporan">
              {tmpListLaporanPengajuan?.length &&
                tmpListLaporanPengajuan.map((e: any, i: any) => {
                  return (
                    <Select.Option key={`lap${i}`} value={e.code}>
                      {e.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
        )}
        <div className="flex flex-row md:flex-col gap-4">
          <div className="flex-1">
            <Form.Item
              label="Kode"
              name="kode"
              rules={[
                {
                  required: true,
                  message: "Kode tidak boleh kosong!",
                },
              ]}>
              <Input
                placeholder="Kode"
                disabled={(tipe === "laporan" && true) || false}
              />
            </Form.Item>
          </div>
          <div className="flex-1">
            <Form.Item
              label="Nama"
              name="nama"
              rules={[
                {
                  required: true,
                  message: "Nama tidak boleh kosong!",
                },
              ]}>
              <Input placeholder="Nama" />
            </Form.Item>
          </div>
        </div>
        {tipe !== "laporan" && (
          <div className="flex flex-row md:flex-col gap-4">
            <div className="flex-1">
              <Form.Item
                label="Template Dokumen"
                name="template"
                validateStatus={errorUpload?.status}
                hasFeedback
                help={errorUpload?.messages}>
                {(updateFileDoc && (
                  <Space>
                    <Button
                      loading={loading}
                      onClick={() => handleOpenDokumen(data)}>
                      Lihat Dokumen
                    </Button>
                    <ButtonTableDelete
                      onClick={() => {
                        Modal.confirm({
                          title: "Perhatian",
                          content: "Yakin Hapus Data?",
                          onOk() {
                            return setUpdateFileDoc(false);
                          },
                          onCancel() {},
                          okText: "Selesai",
                          cancelText: "Batal",
                          okType: "danger",
                        });
                      }}
                    />
                  </Space>
                )) || (
                  <>
                    <ButtonUpload
                      files={validUpload}
                      handleFileUpload={validationAfterUpload}
                    />
                  </>
                )}
              </Form.Item>
            </div>
            <div className="flex-1">
              <Form.Item
                label="Tipe File Upload"
                name="tipeFile"
                rules={[
                  {
                    required: true,
                    message: "Tipe File tidak boleh kosong!",
                  },
                ]}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Pilih Tipe File">
                  {tmpExtensionFile?.length &&
                    tmpExtensionFile.map((e: any, i: any) => {
                      return (
                        <Select.Option key={`filtipe${i}`} value={e.code}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </div>
          </div>
        )}
        {tipeLaporan === "docLpj" && (
          <div className="flex flex-row md:flex-col gap-4">
            <div className="flex-1">
              <Form.Item
                label="Sumber Dana"
                name="sumberDana"
                rules={[
                  {
                    required: true,
                    message: "Sumber Dana tidak boleh kosong!",
                  },
                ]}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Pilih Sumber Dana">
                  {tmpSumberDana?.length &&
                    tmpSumberDana
                      .filter(
                        (item) => item?.madrasah_s === "1" && item?.bos === "1",
                      )
                      .map((e: any, i: any) => {
                        return (
                          <Select.Option key={`sumberDa${i}`} value={e.kode}>
                            {e.nama}
                          </Select.Option>
                        );
                      })}
                </Select>
              </Form.Item>
            </div>
            <div className="flex-1">
              <Form.Item name="month" label="Periode">
                <Checkbox.Group>
                  <div className="grid grid-cols-3 gap-4">
                    {listMonth.map((item: any) => {
                      return (
                        <div>
                          <Checkbox value={item} style={{ lineHeight: "32px" }}>
                            {item}
                          </Checkbox>
                        </div>
                      );
                    })}
                  </div>
                </Checkbox.Group>
              </Form.Item>
            </div>

            <div className="flex-1">
              <Form.Item
                label="Tahun"
                name="year"
                rules={[
                  {
                    required: true,
                    message: "Tahun tidak boleh kosong!",
                  },
                ]}>
                <Radio.Group>
                  <Radio value={isYear - 1}>{isYear - 1}</Radio>
                  <Radio value={isYear}>{isYear}</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default ModalPengajuanDokumen;
